import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'logzy-content-loader',
  templateUrl: './content-loader.component.html',
  styleUrls: ['./content-loader.component.scss']
})
export class ContentLoaderComponent implements OnInit {
  @Input() set1: boolean = false; //card content of 2 select toggle
  @Input() set2: boolean = false;  // card content of stepper input mat-card
  @Input() set3: boolean = false; //card content of multiple view data
  @Input() set3a: boolean = false; //card content of multiple view data without border
  @Input() set4: boolean = false; //card content of message and action btn
  @Input() set5: boolean = false; //card content of timeline
  @Input() set6: boolean = false; //card content of app-chat list
  @Input() set7: boolean = false; //card content of app-chat list
  @Input() set8: boolean = false; //line desc
  @Input() set9: boolean = false; //card content of Ticket from TMS
  @Input() N: number = 7; //its for numbers in app-chat list
  numbers: number[];


  constructor() {
    this.numbers = Array.from({ length: this.N }, (_, index) => index + 1);

  }

  ngOnInit(): void {

  }

}
